<template>
	<div class="form-group">
		<label v-if="name && hideName === false" class="control-label" :for="uniqueId"> {{ $t('label.' + name) }} <small v-if="crequired">*</small></label>
		<div>
			<select
					class="form-control"
					:class="{'is-danger': errors.length > 0}"
					:id="uniqueId"
					:value="value"
					@input="$emit('input', $event.target.value)">
				<!-- option :value="cdefault || ''">-- Изберете --</option -->
				<option v-if="value === null || value === ''" :value="value" class="text-muted">{{cplaceholder}}</option>
				<option v-else-if="allowNone" :value="''" class="text-muted">-- Изчистване --</option>
				<option v-for="(option, key) in values" :value="key" v-if="option.selectable !== false">
					{{ option.text }}
				</option>
				<option v-if="allowOther && values[value] === undefined" :value="value">{{value}}</option>
			</select>
			<span v-show="errors.length > 0" v-for="error in errors" class="help is-danger">{{ error }}</span>
		</div>
	</div>
</template>

<script>
module.exports = {
	name: 'f-select',
	props: {
		value: {type: null, default: undefined},
		name: {type: String},
		allowOther: {type: Boolean, default: false},
		allowNone: {type: Boolean, default: false},
		hideName: {type: null, default: false},
		values: {type: Object, default: () => ({})},
		cdefault: {type: null, default: undefined},
		crequired: {type: Boolean, default: false},
		cplaceholder: {type: String, default: '-- Изберете --'},
		errors: {type: Array, default: () => ([])}
	},
	data: () => ({
		uniqueId: 'input-' + Math.random().toString(16).slice(2)
	})
};
</script>



// WEBPACK FOOTER //
// f-select.vue?241dbcbe